import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getmeetingsDateAction } from "../../actions/mis.action";
import request from "../../services/requestService";
import { getmeetingsDate } from "../../services/apiServices";

class DateList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dates: [],
      page: 0,
      classCount: 0,
      showMore: false,
      requestPayload: {
        sortBy: "CREATED_DATE",
        sortOrder: "DESC",
        offset: 1,
        limit: 8,
        groupCategory: "CENTRAL",
        meetingType: "Cabinet Secretariat",
        recipientState: [],
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      }
    };
    this.handleLoadMore = this.handleLoadMore.bind(this);
  }

  componentDidMount = async () => {
    const { getmeetingsDateAction } = this.props;
    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: 0,
      limit: 8,
      groupCategory: "CENTRAL",
      meetingType: "Cabinet Secretariat",
      recipientState: [],
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };
    const response = await request(getmeetingsDate(requestPayload));
    this.setState({ page: this.state.page + 1 });
    this.setState({ dates: response.data.data.meetingDates });
    getmeetingsDate([], [], 0);
    //Static issue Filter API Call End
  };

  componentDidUpdate = async (prevProps, prevState) => {
    // const{getmeetingsDateAction} = this.props
    let newValue;

    if (
      prevProps.selectedState.value !== this.props.selectedState.value ||
      prevProps.selectMeetingType.value !== this.props.selectMeetingType.value
    ) {
      this.setState({ page: 1 });
      newValue = parseInt(this.props.selectedState.value);
      const newPayload = {
        ...this.state.requestPayload,
        recipientState: this.props.selectedState.value ? [newValue] : [],
        meetingType: this.props.selectMeetingType.value
          ? this.props.selectMeetingType.value
          : "",
        offset: 0
      };

      const response = await request(getmeetingsDate(newPayload));

      this.setState({
        dates: response.data.data.meetingDates,
        showMore: false
      });
      let requestState = {
        sortBy: "CREATED_DATE",
        sortOrder: "DESC",
        offset: 0,
        limit: 8,
        groupCategory: "CENTRAL",
        meetingType: this.props.selectMeetingType.value
          ? this.props.selectMeetingType.value
          : "",
        recipientState: this.props.selectedState.value ? [newValue] : [],
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      };

      this.setState({ requestPayload: requestState });

      //getmeetingsDate([],[], 0)
    }
  };

  async handleLoadMore() {
    const { selectMeetingType, selectedState } = this.props;
    //this.setState({ page: this.state.page + 1 });
    const newValue = parseInt(selectedState.value);
    if (this.state.showMore) {
      this.setState({
        showMore: false,
        page: 1,
        requestPayload: {
          sortBy: "CREATED_DATE",
          sortOrder: "DESC",
          offset: 1,
          limit: 8,
          groupCategory: "CENTRAL",
          meetingType: selectMeetingType ? selectMeetingType.value : "",
          recipientState: this.props.selectedState.value ? [newValue] : [],
          projectCost: [],
          delayedProject: [],
          costOverRun: []
        }
      });

      const requestPayload = {
        sortBy: "CREATED_DATE",
        sortOrder: "DESC",
        offset: 0,
        limit: 8,
        groupCategory: "CENTRAL",
        meetingType: selectMeetingType ? selectMeetingType.value : "",
        recipientState: this.props.selectedState.value ? [newValue] : [],
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      };
      const response = await request(getmeetingsDate(requestPayload));

      this.setState({ dates: response.data.data.meetingDates });
      this.setState({ classCount: 0 });
      //this.setState({page: 0})
    } else {
      this.setState({ classCount: this.state.classCount + 1 });

      const newPayload = {
        ...this.state.requestPayload,
        offset: this.state.page
      };

      this.setState({ requestPayload: newPayload });
      const response = await request(getmeetingsDate(newPayload));

      if (response.data.data.meetingDates.length !== 8) {
        this.setState({ showMore: true });
        this.setState({ page: 1 });
        this.setState({
          requestPayload: {
            sortBy: "CREATED_DATE",
            sortOrder: "DESC",
            offset: 0,
            limit: 8,
            groupCategory: "CENTRAL",
            meetingType: selectMeetingType ? selectMeetingType.value : "",
            recipientState: this.props.selectedState.value ? [newValue] : [],
            projectCost: [],
            delayedProject: [],
            costOverRun: []
          }
        });
      }

      this.setState({
        dates: [...this.state.dates, ...response.data.data.meetingDates]
      });
      this.setState({ page: this.state.page + 1 });
    }
  }

  render() {
    const { dates, page, showMore } = this.state;
    const {
      meetingsDate,
      meetingAppendDates,
      selectedState,
      selectMeetingType,
      meetingsCount
    } = this.props;
    if (meetingsCount.data !== null && meetingsCount.data !== undefined) {
    }

    const selectedmeetingType = JSON.parse(localStorage.getItem("meetingType"));
    let formattedDateArray = [];
    let formattedString;
    if (this.state.dates !== null && this.state.dates !== undefined) {
      formattedDateArray = this.state.dates.map(date => {
        const dateObject = new Date(date * 1000);
        const month = dateObject.getMonth() + 1; // Months are 0-indexed in JavaScript
        const day = dateObject.getDate();
        const year = dateObject.getFullYear();
        const paddedDay = day < 10 ? `0${day}` : day;
        const paddedMonth = month < 10 ? `0${month}` : month;

        return `${paddedDay}-${paddedMonth}-${year}`;
      });

      // const dateArray = formattedDateArray;
      // formattedString = dateArray.join(", ");
      if (this.state.dates !== null && this.state.dates !== undefined) {
        formattedString = "";
        let line = "";
        for (let i = 0; i < formattedDateArray.length; i++) {
          line += formattedDateArray[i] + ", ";
          if ((i + 1) % 4 === 0 || i === formattedDateArray.length - 1) {
            formattedString += line.slice(0, -2) + "\n"; // remove trailing comma and add newline
            line = "";
          }
        }
      }
    }
    const initialDates = showMore
      ? formattedDateArray
      : formattedDateArray.slice(0, 10);
    const remainingDates = !showMore ? [] : formattedDateArray.slice(10);
    // const joinedDates = formattedDateArray.join(', ');
    //const conditionalClassName = this.state.classCount % 2 === 0 ? 'read-more-button' : 'inactive';

    let conditionalClassName;
    if (
      formattedDateArray.length < 4 ||
      formattedDateArray.length == 6 ||
      formattedDateArray.length == 7 ||
      formattedDateArray.length == 19
    ) {
      conditionalClassName = "pre-string1";
    } else {
      conditionalClassName = "pre-string";
    }

    return (
      <>
        <div className="pre-string-div">
          {/* <pre className={conditionalClassName}>{formattedString ? formattedString : "-" }
        
              
              
            
            </pre> */}
          {formattedDateArray.map((date, index) => (
            <span
              style={{
                width: "81px",
                display: "block",
                float: "left",
                textAlign: "justify"
              }}
            >
              {index === formattedDateArray.length - 1 ? date : `${date}, `}
            </span>
          ))}
          {formattedDateArray.length === 0 && <span>-</span>}

          {meetingsCount.data !== null &&
            meetingsCount.data !== undefined &&
            meetingsCount.data.agendaCount > 8 && (
              <button
                onClick={this.handleLoadMore}
                className="read-more-button"
              >
                {showMore ? "Show Less" : `Show More`}
                {showMore ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} />
                )}
              </button>
            )}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    meetingsDate: state.misReducer.meetingsDate,
    meetingAppendDates: state.misReducer.meetingAppendDates,
    selectedState: state.misReducer.selectedState,
    selectMeetingType: state.misReducer.selectMeetingType,
    meetingsCount: state.misReducer.meetingsCount
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getmeetingsDateAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateList);
